const states = new Map<
  string,
  {
    locked: boolean;
    result: unknown;
  }
>();

/**
 * Clears the cached result for a given key.
 * @function clearCache
 * @param {string} key - The key for which to clear the cache.
 */
const clearCache = (key: string) => {
  const state = states.get(key);
  if (!state) return;
  state.result = undefined;
};

export { clearCache };
